import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as deTitles } from '../i18n/de.titles.json';
import { provideBelegleserGlobals } from './belegleser.globals';
import { belegleserRoutes } from './belegleser.routes';
import {
  BelegleserConfig,
  SOFTLINE_MODULE_BELEGLESER,
  SOFTLINE_PERMISSION_BELEGLESER,
} from './belegleser.shared';

// Legacy (monolith) entry — the NF shell loads src/federation/* instead.
// Two-export pattern: keep this and the federation entries in sync.
export const provideBelegleserModule = (
  config?: BelegleserConfig
): Array<Provider | EnvironmentProviders> => [
  provideSoftAppsModule(
    {
      name: SOFTLINE_MODULE_BELEGLESER,
      title: '#BELEGLESER.TITLE',
      icon: 'fa-regular fa-file-magnifying-glass',
      route: '/belegleser',
      permission: SOFTLINE_PERMISSION_BELEGLESER,
      group: getModuleGroupByName('Workflow'),
    },
    withSoftAppsModuleRoutes({ app: belegleserRoutes }),
    withLazySoftAppsModuleTranslation({
      eager: { de: deTitles },
      lazy: { de: () => import('../i18n/de.json') },
    }),
    withSoftAppsModuleInfo({
      library: '@softapps/belegleser',
      description: 'Lieferantenbelege lesen, prüfen und Templates zeichnen.',
    })
  ),
  ...provideBelegleserGlobals(config),
];
